interface CircularProgressBarProps {
	values: number[];
	colors: string[];
	total: number;
	size?: number;
	strokeWidth?: number;
	className?: string;
}

const CircularProgressBar = ({
	total,
	values,
	colors,
	size = 100,
	strokeWidth = 10,
	className,
}: CircularProgressBarProps) => {
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;

	// Calcula a posição inicial para cada segmento
	const calculateOffsets = () => {
		let totalOffset = 0;
		return values.map((value) => {
			const offset = totalOffset;
			totalOffset += value;
			return offset;
		});
	};

	const offsets = calculateOffsets();

	return (
		<svg width={size} height={size}>
			<circle
				cx={size / 2}
				cy={size / 2}
				r={radius}
				fill="none"
				stroke="#f5f5f5"
				strokeWidth={strokeWidth}
			/>
			{values.map((value, index) => (
				<circle
					key={index}
					cx={size / 2}
					cy={size / 2}
					r={radius}
					fill="none"
					stroke={colors[index]}
					strokeWidth={strokeWidth}
					strokeDasharray={`${(value / total) * circumference} ${circumference}`}
					strokeDashoffset={-(offsets[index] / total) * circumference}
					transform={`rotate(-90, ${size / 2}, ${size / 2})`}
				/>
			))}
		</svg>
	);
};

export default CircularProgressBar;
